import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/framework/service/snack-bar.service';
import { ConsentService } from '../my-consent.service';

@Component({
  selector: 'app-edit-my-consent',
  templateUrl: './edit-my-consent.component.html',
  styleUrls: ['./edit-my-consent.component.scss']
})
export class EditMyConsentComponent implements OnInit {
  constructor(

    private readonly pservice: ConsentService,
    private readonly snackBar: SnackBarService,
    public dialogRef: MatDialogRef<EditMyConsentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

  }

  onConfirm(): void {
    const payload = this.data?.payload;
    if (!payload) {
      this.snackBar.error('Unable to save: missing consent payload.');
      return;
    }

    this.pservice.updatePatientConsents(payload).subscribe({
      next: () => {
        this.dialogRef.close(true);
        this.snackBar.success('Success! Consent updated successfully.');
      },
      error: (error) => {
        this.snackBar.error(error?.error?.applicationMessage || 'Failed to update consent');
      }
    });
  }

}
